/*
  Looping section videos: play while on screen, stay still for visitors who ask for reduced motion.
*/

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const videos = document.querySelectorAll('[data-mm-video]');

const observer = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting && !reduceMotion.matches) entry.target.play().catch(() => {});
    else entry.target.pause();
  }
});

videos.forEach((video) => observer.observe(video));
